import React from 'react';
import { useI18n, useTranslation } from '../i18n';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useI18n();
  const { t } = useTranslation();

  const handleChange = (lang) => (e) => {
    e.preventDefault();
    if (lang === language) return;
    const scrollY = window.scrollY;
    setLanguage(lang);
    // Restaurar posición de scroll tras el re-render
    requestAnimationFrame(() => {
      window.scrollTo({ top: scrollY, behavior: 'instant' });
    });
  };

  return (
    <div
      className="tz-lang-toggle"
      aria-label={t('common.language')}
      role="group"
    >
      <button
        type="button"
        className={`tz-lang-btn${language === 'es' ? ' tz-lang-btn--active' : ''}`}
        onClick={handleChange('es')}
        aria-pressed={language === 'es'}
        title={t('common.switchToSpanish')}
      >
        ES
      </button>
      <button
        type="button"
        className={`tz-lang-btn${language === 'en' ? ' tz-lang-btn--active' : ''}`}
        onClick={handleChange('en')}
        aria-pressed={language === 'en'}
        title={t('common.switchToEnglish')}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
